<!-- eslint-disable max-len -->
<route>
{
  "meta": {
    "requireAdmin": true,
    "customSite": true
  }
}
</route>
<template>
  <div class="py-1 px-3">
    <div class="flex-nowrap w-full flex justify-between items-center mb-4">
      <div class="text-xl mr-5">Enrolled Students</div>
      <div class="text-xl text-right flex flex-nowrap">
        <button type="button" class="btn btn-primary" @click="invitePopup = true" :disabled="enrolledStudents.length === 0">
          Invite
        </button>
        <button type="button" class="btn ml-3 btn-primary" @click="setModalDetails('enrolled', true)" :disabled="enrolledStudents.length === 0">
          Remove
        </button>
        <button type="button" class="btn ml-3 btn-primary" @click="setModalDetails('enrolled')" :disabled="enrolledStudents.length === 0">
          Send DM
        </button>
        <button type="button" class="btn ml-3 btn-primary" @click="downloadCSVEnrolled" :disabled="enrolledStudents.length === 0">
          Export
        </button>
      </div>
    </div>
    <div class="pb-8">
      <div class="border-b border-gray-200">
        <table class="min-w-full divide-y divide-gray-200">
          <thead class="bg-white">
            <tr>
              <th scope="col" class="px-6 py-3 text-left">
                <input
                  type="checkbox"
                  checked="checked"
                  :disabled="enrolledStudents.length === 0"
                  class="checkbox checkbox-primary align-middle"
                  v-model="allEnrolled"
                  @change="handleCheck($event, 'allEnrolled')"
                />
              </th>
              <th
                scope="col"
                class="px-6 py-3 text-left text-xs font-bold text-gray-900 uppercase tracking-wider"
              >
                #
              </th>
              <th
                scope="col"
                class="px-6 py-3 text-left text-xs font-bold text-gray-900 uppercase tracking-wider"
              >
                Name
              </th>
              <th
                scope="col"
                class="px-12 py-3 text-left text-xs font-bold text-gray-900 uppercase tracking-wider"
              >
                Twitter Name
              </th>
              <th
                scope="col"
                class="px-6 py-3 text-left text-xs font-bold text-gray-900 uppercase tracking-wider"
              >
                Email
              </th>
              <th
                scope="col"
                class="px-6 py-3 text-left text-xs font-bold text-gray-900 uppercase tracking-wider"
              >
                Enrolled Date
              </th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
            <tr v-if="enrolledStudents && enrolledStudents.length === 0">
              <td colspan="5" class="px-6 py-3 text-center">
                <div class="flex justify-center mt-4">
                  <div class="flex-shrink-0">
                    <svg
                      class="h-5 w-5 text-blue-400"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </div>
                  <div class="ml-2">
                    <p class="text-sm text-blue-700">
                      There are no members added to this segment yet.
                    </p>
                  </div>
                </div>
              </td>
            </tr>
            <tr v-for="(student, index) in enrolledStudents" :key="index">
              <td class="px-6 py-4">
                <input
                  type="checkbox"
                  checked="checked"
                  class="checkbox checkbox-primary align-middle"
                  v-model="enrolled[index]"
                />
              </td>
              <td class="px-6 py-4 whitespace-nowrap font-thin text-gray-500">
                {{ index + 1 }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-gray-900">
                {{ student.name ? student.name : `-` }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-gray-900">
                <a
                  class="px-6 py-4 whitespace-nowrap text-gray-900"
                  target="_blank"
                  :href="'https://twitter.com/' + student.acctUsername"
                > {{ student.acctUsername ? student.acctUsername : `-` }} </a>
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-gray-900">
                {{ student.email ? student.email : `-` }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-gray-900">
                {{ student.createdAt ? showDateTime(student.createdAt) : `-` }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="flex-nowrap w-full flex justify-between items-center mb-4">
      <div class="text-xl mr-5">Waitlist Students</div>
      <div class="text-xl text-right flex flex-nowrap">
        <button type="button" class="btn btn-primary" @click="setModalDetails('waitlist', true)" :disabled="waitlistStudents.length === 0">
          Remove
        </button>
        <button type="button" class="btn ml-3 btn-primary" @click="setModalDetails('waitlist')" :disabled="waitlistStudents.length === 0">
          Send DM
        </button>
        <button type="button" class="btn ml-3 btn-primary" @click="downloadCSVWaitlist" :disabled="waitlistStudents.length === 0">
          Export
        </button>
      </div>
    </div>
    <div class="pb-4">
      <div class="border-b border-gray-200">
        <table class="min-w-full divide-y divide-gray-200">
          <thead class="bg-white">
            <tr>
              <th scope="col" class="px-6 py-3 text-left">
                <input
                  type="checkbox"
                  checked="checked"
                  class="checkbox checkbox-primary align-middle"
                  :disabled="waitlistStudents.length === 0"
                  v-model="allWaitlist"
                  @change="handleCheck($event, 'allWaitlist')"
                />
              </th>
              <th
                scope="col"
                class="px-6 py-3 text-left text-xs font-bold text-gray-900 uppercase tracking-wider"
              >
                #
              </th>
              <th
                scope="col"
                class="px-6 py-3 text-left text-xs font-bold text-gray-900 uppercase tracking-wider"
              >
                Name
              </th>
              <th
                scope="col"
                class="px-12 py-3 text-left text-xs font-bold text-gray-900 uppercase tracking-wider"
              >
                Twitter Name
              </th>
              <th
                scope="col"
                class="px-6 py-3 text-left text-xs font-bold text-gray-900 uppercase tracking-wider"
              >
                Email
              </th>
              <th
                scope="col"
                class="px-6 py-3 text-left text-xs font-bold text-gray-900 uppercase tracking-wider"
              >
                Enrolled Date
              </th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
            <tr v-if="waitlistStudents && waitlistStudents.length === 0">
              <td colspan="5" class="px-6 py-3 text-center">
                <div class="flex justify-center mt-4">
                  <div class="flex-shrink-0">
                    <svg
                      class="h-5 w-5 text-blue-400"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </div>
                  <div class="ml-2">
                    <p class="text-sm text-blue-700">
                      There are no students on the waitlist for this course yet.
                    </p>
                  </div>
                </div>
              </td>
            </tr>
            <tr v-for="(student, index) in waitlistStudents" :key="index">
              <td class="px-6 py-4">
                <input
                  type="checkbox"
                  checked="checked"
                  class="checkbox checkbox-primary align-middle"
                  v-model="waitlist[index]"
                />
              </td>
              <td class="px-6 py-4 whitespace-nowrap font-thin text-gray-500">
                {{ index + 1 }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-gray-900">
                {{ student.name ? student.name : `-` }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-gray-900">
                <a
                  class="px-6 py-4 whitespace-nowrap text-gray-900"
                  target="_blank"
                  :href="'https://twitter.com/' + student.acctUsername"
                > {{ student.acctUsername ? student.acctUsername : `-` }} </a>
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-gray-900">
                {{ student.email ? student.email : `-` }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-gray-900">
                {{ student.createdAt ? showDateTime(student.createdAt) : `-` }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <transition
      enter-active-class="transition duration-300 ease-out transform"
      enter-class="scale-95 opacity-0"
      enter-to-class="scale-100 opacity-100"
      leave-active-class="transition duration-150 ease-in transform"
      leave-class="scale-100 opacity-100"
      leave-to-class="scale-95 opacity-0"
    >
      <div
        v-if="feedPopup"
        class="flex items-center justify-center fixed left-0 bottom-0 w-full h-full"
        style="background-color: #00000099"
      >
        <div class="bg-white rounded-lg w-1/4">
          <div class="flex flex-col items-start p-4">
            <div class="flex items-center w-full">
              <div class="text-gray-900 font-bold text-lg">Send DM</div>
              <svg
                class="ml-auto fill-current text-gray-700 w-6 h-6 cursor-pointer"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 18 18"
                @click="closePopup"
              >
                <path
                  d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
                />
              </svg>
            </div>
            <hr class="w-full my-3" />
            <textarea
              class="textarea h-40 textarea-bordered w-full mb-1"
              placeholder="Message"
              required
              name="message"
              v-model="message"
            />
            <hr class="w-full my-3" />
            <div class="ml-auto">
              <button :disabled="message.trim() === ''" class="btn btn-primary" @click="SendConfirmed">Send</button>
              <button class="btn btn-outline ml-3" @click="closePopup">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition
      enter-active-class="transition duration-300 ease-out transform"
      enter-class="scale-95 opacity-0"
      enter-to-class="scale-100 opacity-100"
      leave-active-class="transition duration-150 ease-in transform"
      leave-class="scale-100 opacity-100"
      leave-to-class="scale-95 opacity-0"
    >
      <div
        v-if="failedPopup"
        class="flex items-center justify-center fixed left-0 bottom-0 w-full h-full"
        style="background-color: #00000099"
      >
        <div class="bg-white rounded-lg w-1/4">
          <div class="flex flex-col items-start p-4">
            <div class="flex items-center w-full">
              <div class="text-gray-900 font-bold text-lg">
                {{ successcount }} DM sent successfully
              </div>
              <svg
                v-if="failedDmlist.length"
                class="ml-auto fill-current text-gray-700 w-6 h-6 cursor-pointer"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 18 18"
                @click="failedPopup = false"
              >
                <path
                  d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
                />
              </svg>
            </div>
            <hr v-if="failedDmlist.length" class="w-full my-3" />
            <div v-if="failedDmlist.length" class="text-gray-900 font-bold text-lg">
              Failed for {{ failedDmlist.length }}
            </div>
            <div v-for="(student, index) in failedDmlist" :key="index">
              <div class="text-gray-900">{{ student.userName }}</div>
            </div>
            <hr v-if="failedDmlist.length" class="w-full my-3" />
            <div class="ml-auto">
              <button class="btn btn-primary" @click="failedPopup = false">Done</button>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition
      enter-active-class="transition duration-300 ease-out transform"
      enter-class="scale-95 opacity-0"
      enter-to-class="scale-100 opacity-100"
      leave-active-class="transition duration-150 ease-in transform"
      leave-class="scale-100 opacity-100"
      leave-to-class="scale-95 opacity-0"
    >
      <div
        v-if="removePopup"
        class="
          flex
          items-center
          justify-center
          fixed
          left-0
          bottom-0
          w-full
          h-full
        "
        style="background-color: #00000099"
      >
        <div class="bg-white rounded-lg w-1/4">
          <div class="flex flex-col items-start p-4">
            <div class="flex items-center w-full">
              <div class="text-gray-900 font-bold text-lg">
                Remove Confirmation
              </div>
              <svg
                class="
                  ml-auto
                  fill-current
                  text-gray-700
                  w-6
                  h-6
                  cursor-pointer
                "
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 18 18"
                @click="removePopup = false"
              >
                <path
                  d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
                />
              </svg>
            </div>
            <hr class="w-full my-3" />
            <div class="">Are you sure you want to remove this user?</div>
            <div class="form-control mt-2" v-if="DMto === 'enrolled'">
              <label class="cursor-pointer label justify-start" style="width: fit-content">
                <input
                  type="checkbox"
                  checked="removesubmissions"
                  class="checkbox checkbox-primary"
                  v-model="removesubmissions"
                />
                <span class="label-text text-lg ml-3">Also remove user submissions</span>
              </label>
            </div>
            <hr class="w-full my-3" />
            <div class="ml-auto">
              <button class="btn btn-primary" @click="removeConfirmed">
                Yes
              </button>
              <button class="btn btn-outline ml-3" @click="removePopup = false">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition
      enter-active-class="transition duration-300 ease-out transform"
      enter-class="scale-95 opacity-0"
      enter-to-class="scale-100 opacity-100"
      leave-active-class="transition duration-150 ease-in transform"
      leave-class="scale-100 opacity-100"
      leave-to-class="scale-95 opacity-0"
    >
      <div
        v-if="invitePopup"
        class="
          flex
          items-center
          justify-center
          fixed
          left-0
          bottom-0
          w-full
          h-full
        "
        style="background-color: #00000099"
      >
        <div class="bg-white rounded-lg w-1/2 max-h-95/100">
          <div class="flex flex-col items-start p-4">
            <div class="flex items-center w-full">
              <div class="text-gray-900 font-bold text-lg">Invite Students</div>
              <svg
                class="
                  ml-auto
                  fill-current
                  text-gray-700
                  w-6
                  h-6
                  cursor-pointer
                "
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 18 18"
                @click="invitecancel"
              >
                <path
                  d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
                />
              </svg>
            </div>
            <hr class="w-full my-3" />
            <div class="form-control w-full">
              <div class="mr-auto mt-3">
                <button
                  :class="
                    Type === 'username' ? 'btn btn-primary' : 'btn btn-outline'
                  "
                  @click="
                    Type = 'username';
                  "
                >
                  From username
                </button>
                <button
                  :class="
                    Type === 'Engagement'
                      ? 'btn btn-primary ml-3'
                      : 'btn btn-outline ml-3'
                  "
                  @click="
                    Type = 'Engagement';
                  "
                >
                  From Engagement
                </button>
              </div>
              <label class="cursor-pointer label mt-2 justify-start" style="width: fit-content">
                <input
                  type="checkbox"
                  checked="sendnotification"
                  class="checkbox checkbox-primary"
                  v-model="enroll"
                />
                <span class="label-text text-lg ml-3">Enroll without invitation</span>
              </label>
              <input
                type="text"
                :placeholder= "Type === 'username' ? 'Twitter Username' : 'Tweet Url'"
                class="input mt-3 input-bordered w-full mb-2"
                required
                name="enrollusername"
                :input="(enrollusername = enrollusername.trim())"
                v-model="enrollusername"
              />
              <label v-if="enroll" class="cursor-pointer label justify-start" style="width: fit-content">
                <input
                  type="checkbox"
                  checked="sendnotification"
                  class="checkbox checkbox-primary"
                  v-model="sendnotification"
                />
                <span class="label-text text-lg ml-3">Notify users of being enrolled into course</span>
              </label>
              <div class="form-control mt-2" v-if="Type === 'Engagement'">
                <label class="cursor-pointer label justify-start" style="width: fit-content">
                  <input
                    type="checkbox"
                    checked="sendnotification"
                    class="checkbox checkbox-primary"
                    v-model="Comments"
                  />
                  <span class="label-text text-lg ml-3"> Replies / Comments</span>
                </label>
                <label class="cursor-pointer label justify-start" style="width: fit-content">
                  <input
                    type="checkbox"
                    checked="sendnotification"
                    class="checkbox checkbox-primary"
                    v-model="Likes"
                  />
                  <span class="label-text text-lg ml-3"> Likes</span>
                </label>
                <label class="cursor-pointer label justify-start" style="width: fit-content">
                  <input
                    type="checkbox"
                    checked="sendnotification"
                    class="checkbox checkbox-primary"
                    v-model="Retweets"
                  />
                  <span class="label-text text-lg ml-3">Retweets</span>
                </label>
              </div>
              <textarea
                v-if="!enroll"
                class="textarea h-32 mt-2 textarea-bordered w-full mb-1"
                placeholder="Message"
                required
                name="content"
                v-model="content"
              />
            </div>
            <hr class="w-full my-3" />
            <div class="ml-auto">
              <button
                :disabled="
                  Type === 'Engagement'
                    ? enrollusername.indexOf('https://twitter.com/') === -1 || ( !enroll && content.trim() === '') || ( !Retweets && !Likes && !Comments )
                    : ( !enroll && content.trim() === '')  || enrollusername.trim() === ''
                "
                class="btn btn-primary"
                @click="inviteUser"
              >
                Send Invite
              </button>
              <button
                class="btn btn-outline ml-3"
                @click="invitecancel"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
import moment from 'moment';
import store from '@/store';
import userInfo from '@/services/userInfo';
import courseAPI from '@/services/course';
import admin from '@/services/admin';
import utils from '@/services/utils';

export default {
  name: 'enrolledStudent',
  layout: 'admin',
  store,
  data() {
    return {
      students: [],
      enrolledStudents: [],
      waitlistStudents: [],
      courseId: '',
      courseName: '',
      enrolled: [],
      waitlist: [],
      allEnrolled: false,
      allWaitlist: false,
      feedPopup: false,
      removePopup: false,
      invitePopup: false,
      Type: 'username',
      content: '',
      Comments: false,
      Likes: false,
      Retweets: false,
      enrollusername: '',
      enroll: false,
      sendnotification: true,
      failedPopup: false,
      removesubmissions: false,
      message: '',
      dmstudents: [],
      failedDmlist: [],
      DMto: '',
      successcount: null,
    };
  },
  computed: {
    user() {
      return store.state.user;
    },
  },
  async mounted() {
    this.courseId = this.$route.params.courseId;
    this.courseData = await courseAPI.getCourse(this.courseId);
    this.courseName = this.courseData.course.title;
    this.content = `I think you will like my new series: ${this.courseName}`;
    this.fetchStudentList();
  },
  methods: {
    fetchStudentList() {
      store.commit('toggleLoading', true);
      userInfo
        .getEnrolledStudents(this.courseId)
        .then((data) => {
          store.commit('toggleLoading', false);
          console.log(data);
          this.enrolled = [];
          this.waitlist = [];
          this.enrolledStudents = data.enrolledStudents;
          this.waitlistStudents = data.waitlistStudents;
          for (let i = 0; i < this.enrolledStudents.length; i += 1) {
            this.enrolled.push(false);
          }
          for (let i = 0; i < this.waitlistStudents.length; i += 1) {
            this.waitlist.push(false);
          }
        })
        .catch((error) => {
          store.commit('toggleLoading', false);
          if (error.response.status === 401) {
            utils.setStatusMsg(this, 'Unauthorized access, redirected to implicit');
            this.$router.push({ path: '/' });
          }
          console.log({ error });
        });
    },
    closePopup() {
      this.feedPopup = false;
    },
    showDateTime(DateTime) {
      return moment(DateTime).fromNow();
    },
    invitecancel() {
      this.invitePopup = false;
      this.enrollusername = '';
      this.content = `I think you will like my new series: ${this.courseName}`;
      this.Type = 'username';
      this.Comments = false;
      this.Retweets = false;
      this.Likes = false;
    },
    inviteUser() {
      console.log(this.content, this.enrollusername);
      store.commit('toggleLoading', true);
      userInfo
        .inviteUser({
          username: this.enrollusername,
          courseId: this.courseId,
          creatorId: this.user.uid,
          message: this.content,
          Type: this.Type,
          enroll: this.enroll,
          sendnotification: this.sendnotification,
          Comments: this.Comments,
          Retweets: this.Retweets,
          Likes: this.Likes,
        })
        .then((res) => {
          console.log(res);
          this.invitecancel();
          // store.commit('toggleLoading', false);
          utils.setStatusMsg(
            this,
            res.message,
          );
          this.fetchStudentList();
        })
        .catch((error) => {
          this.invitecancel();
          store.commit('toggleLoading', false);
          utils.setStatusMsg(
            this,
            error.message,
          );
          console.log({ error });
        });
    },
    removeConfirmed() {
      this.removePopup = false;
      store.commit('toggleLoading', true);
      userInfo
        .removeStudent({
          studentType: this.DMto, studentId: this.dmstudents, courseId: this.courseId, removesubmissions: this.removesubmissions,
        })
        .then((res) => {
          console.log(res);
          this.fetchStudentList();
        })
        .catch((error) => {
          store.commit('toggleLoading', false);
          console.log({ error });
        });
    },
    downloadCSVEnrolled() {
      if (this.enrolledStudents.length) {
        let csv = 'Name,Twitter Name,Email,Enrolled Date\n';
        this.enrolledStudents.forEach((row) => {
          console.log(row);
          csv = `${csv}${row.name ? row.name : '-'},${row.acctUsername ? row.acctUsername : '-'},${row.email ? row.email : '-'},${row.createdAt ? row.createdAt : '-'}`;
          csv = `${csv}\n`;
        });
        const anchor = document.createElement('a');
        anchor.href = `data:text/csv;charset=utf-8, ${encodeURIComponent(csv)}`;
        anchor.target = '_blank';
        anchor.download = 'EnrolledStudents.csv';
        anchor.click();
      } else {
        utils.setStatusMsg(this, 'No Enrolled Students to export');
      }
    },
    downloadCSVWaitlist() {
      if (this.waitlistStudents.length) {
        let csv = 'Name,Twitter Name,Email,Enrolled Date\n';
        this.waitlistStudents.forEach((row) => {
          console.log(row);
          csv = `${csv}${row.name ? row.name : '-'},${row.acctUsername ? row.acctUsername : '-'},${row.email ? row.email : '-'},${row.createdAt ? row.createdAt : '-'}`;
          csv = `${csv}\n`;
        });
        const anchor = document.createElement('a');
        anchor.href = `data:text/csv;charset=utf-8, ${encodeURIComponent(csv)}`;
        anchor.target = '_blank';
        anchor.download = 'WaitlistStudents.csv';
        anchor.click();
      } else {
        utils.setStatusMsg(this, 'No Waitlist Students to export');
      }
    },
    async SendConfirmed() {
      store.commit('toggleLoading', true);
      console.log(this.message);
      console.log(this.dmstudents);
      const data = {
        providerIds: this.dmstudents,
        message: this.message,
      };
      await admin
        .sendDM(data)
        .then((data1) => {
          store.commit('toggleLoading', false);
          console.log(data1);
          this.failedDmlist = data1.failedUsers;
          this.successcount = data1.successUsersCount;
          this.feedPopup = false;
          this.failedPopup = true;
        })
        .catch((error) => {
          store.commit('toggleLoading', false);
          if (error.response.status === 401) {
            utils.setStatusMsg(this, 'Failed to send DM');
            this.$router.push({ path: '/' });
          }
          console.log(error);
        });
      this.message = '';
    },
    setModalDetails(dm, isdelete = false) {
      this.DMto = dm;
      const studentdata = [];
      if (this.DMto === 'enrolled') {
        for (let i = 0; i < this.enrolledStudents.length; i += 1) {
          if (this.enrolled[i] === true) {
            studentdata.push(isdelete ? this.enrolledStudents[i].userRefId : this.enrolledStudents[i].providerId);
          }
        }
      } else {
        for (let i = 0; i < this.waitlistStudents.length; i += 1) {
          if (this.waitlist[i] === true) {
            studentdata.push(isdelete ? this.waitlistStudents[i].userRefId : this.waitlistStudents[i].providerId);
          }
        }
      }
      if (studentdata.length) {
        this.dmstudents = studentdata;
        this.feedPopup = !isdelete;
        this.removePopup = isdelete;
      } else {
        utils.setStatusMsg(this, 'Please select at least one Student');
      }
    },
    handleCheck(e, what) {
      if (what === 'allEnrolled') {
        this.enrolled.forEach((_, index) => {
          this.enrolled[index] = e.target.checked;
        });
      } else if (what === 'allWaitlist') {
        this.waitlist.forEach((_, index) => {
          this.waitlist[index] = e.target.checked;
        });
      }
    },
  },
};
</script>
